import ROUTER_CONSTANT from "./RouterConstant";

const PAGE_CONSTANT = {
  STATEMENT: {
    TITLE: "My Statement",
    DESCRIPTION: "View your payment history",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  SOCIETY_STATEMENT: {
    TITLE: "Society Statement",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  ADD_ASSET: {
    PATH_PARAMS: {
      FAMILY: "FAMILY_MEMBER",
      TENANT: "TENANT",
      VEHICLE: "VEHICLE",
      PET: "PET",
      EN: "EMERGENCY_NUMBER",
    },
    FAMILY: "Add Family Member",
    TENANT: "Add Tenant",
    VEHICLE: "Add Vehicle",
    PET: "Add Pet",
    EN: "Add Emergency Number",
    BACK_LOCATION: ROUTER_CONSTANT.PROFILE.ROOT,
  },
  PROFILE: {
    TITLE: "Profile",
    DESCRIPTION: "Manage your account and preferences",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  HOME: {
    TITLE: "Home",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  NOTIFICATION: {
    TITLE: "Notifications",
    DESCRIPTION: "Your recent alerts and updates",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  MEMBER: {
    TITLE: "Members",
    DESCRIPTION: "View all society residents",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  CHAT: {
    TITLE: "Chat",
    DESCRIPTION: "Society group conversations",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  GALLARY: {
    TITLE: "Gallery",
    DESCRIPTION: "Browse society photos and albums",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  FUNCTION: {
    TITLE: "Events",
    DESCRIPTION: "Upcoming and past society events",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  FUNCTION_DETAIL: {
    TITLE: "Event Details",
    DESCRIPTION: "Full details and RSVP",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.FUNCTION,
  },
  NOTICE_BOARD: {
    TITLE: "Notice Board",
    DESCRIPTION: "Society announcements and updates",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  VISITOR: {
    TITLE: "Visitors",
    DESCRIPTION: "Track and approve guest access",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  COMPLAINT: {
    TITLE: "Complaints",
    DESCRIPTION: "Submit and monitor issues",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  ALL_MENU: {
    TITLE: "All Menu",
    DESCRIPTION: "Browse all features",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  POLLING: {
    TITLE: "Polls",
    DESCRIPTION: "Vote on society matters",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  ELECTION: {
    TITLE: "Elections",
    DESCRIPTION: "Participate in committee elections",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  USER_QR: {
    TITLE: "My QR",
    DESCRIPTION: "Your gate access pass",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  ADDRESS: {
    TITLE: "My Address",
    DESCRIPTION: "Your registered flat details",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  SOCIETY_DOX: {
    TITLE: "Society Docs",
    DESCRIPTION: "Access important society documents",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  SOCIETY_DETAIL: {
    TITLE: "Society Details",
    DESCRIPTION: "Info about your housing society",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  ONBOARDING: {
    TITLE: "",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  FUND: {
    TITLE: "Society Fund",
    DESCRIPTION: "Manage and view fund transactions",
    DESCRIPTION_VIEW_ONLY: "View fund transactions",
    BACK_LOCATION: ROUTER_CONSTANT.ROOT.HOME,
  },
  SOCIETY_ADMIN: {
    TITLE: "Admin Panel",
    BACK_LOCATION: ROUTER_CONSTANT.SOCIETY.USER_PROFILE,
    EN: {
      MANAGE_PAGE_TITLE: "Manage Emergency Number",
      ADD_PAGE_TITLE: "Add Emergency Number"
    },
    GUARD: {
      MANAGE_PAGE_TITLE: "Manage Guard",
      ADD_PAGE_TITLE: "Add Guard"
    },
    PATH_PARAMS: {
      FAMILY: "FAMILY_MEMBER",
      VEHICLE: "VEHICLE",
      PET: "PET",
      EN: "ADMIN_EMERGENCY_NUMBER",
    }
  },
};
export default PAGE_CONSTANT;
